<style>

</style>
<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="lcwpInsurance/findInsuranceUserListByAdmin.action"
                        ref="insuranceUserListTable">
            <template slot="search">
                <el-row :gutter="2">
                    <el-col :span="22">

                    <el-input style="width: 200px"  class="jl" placeholder="昵称/账号" v-model="queryParams.keyword"></el-input>
                    <el-button @click="$refs.insuranceUserListTable.search()" type="primary">搜索</el-button>
                    </el-col>
                </el-row>

            </template>
            <template slot="item">
                <el-table-column
                        label="昵称/账号"
                        prop="name">
                </el-table-column>
                <el-table-column
                        label="手机号"
                        prop="phone">
                </el-table-column>
                <el-table-column
                        label="累计获得绿豆"
                        prop="totalCount">
                </el-table-column>

                <el-table-column
                        label="已使用绿豆"
                        prop="usedCount">
                </el-table-column>

                <el-table-column
                        label="可用绿豆"
                        prop="canUseCount">
                </el-table-column>

                <el-table-column
                        label="创建时间"
                        prop="createDate">
                    <template scope="scope">
                        {{ scope.row.createTime| dateTimeFormat }}
                    </template>
                </el-table-column>

                <el-table-column
                        label="操作" width="150px">
                    <template scope="scope">
                        <el-dropdown trigger="click">
                            <el-button class="el-dropdown-link" size="mini" type="primary">
                                更多操作<i class="el-icon-caret-bottom el-icon--right" style="color:#FFF"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native.prevent="rewardMungBean(scope.row)" v-permissions="'rewardMungBeanPermissions'">奖励绿豆</el-dropdown-item>
                                <el-dropdown-item @click.native.prevent="deductionMungBean(scope.row)"  v-permissions="'deductionMungBeanPermissions'">扣减绿豆</el-dropdown-item>
                                <el-dropdown-item @click.native.prevent="showInsuranceMungBeanData(scope.row.id)" >收支明细</el-dropdown-item>
                                <el-dropdown-item @click.native.prevent="showInsuranceOrderData(scope.row.id)" >查看智保订单</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </template>
        </table-template>
        <el-dialog :visible.sync="dialogInsuranceUserFormVisible"  title="绿豆奖励"
                               width="40%">
        <el-form :rules="rules"  :model="dialogInsuranceForm" label-position="left" ref="dialogInsuranceForm">

            <el-form-item label="奖励绿豆数量" label-width="120px" prop="count">
                <el-input  v-model.number="dialogInsuranceForm.count" placeholder="请输入"  type="text" step="0" >
                    <template slot="append">绿豆
                    </template>
                </el-input>
                提示：10绿豆价值1元，请谨慎操作!
            </el-form-item>
            <el-form-item label="原因" label-width="120px" prop="remark">
                <el-input :rows="4"  placeholder="请输入操作理由" size="medium"
                          type="textarea"
                          v-model="dialogInsuranceForm.remark"></el-input>
            </el-form-item>

        </el-form>
        <div class="dialog-footer" slot="footer">

            <el-button @click="saveRewardMungBean()" type="primary">确认无误</el-button>
        </div>
    </el-dialog>

        <el-dialog :visible.sync="deductionDialogInsuranceUserVisible"  title="绿豆扣减"
                   width="40%">
            <row style="font-size: 20px;margin-bottom: 20px;"></row>
            <el-form :rules="rules"  :model="dialogInsuranceForm" label-position="left" ref="dialogInsuranceForm">

                <el-form-item label="扣减绿豆数量" label-width="120px" prop="count">
                    <el-input  v-model.number="dialogInsuranceForm.count" placeholder="请输入"  type="text" step="0" >
                        <template slot="append">绿豆
                        </template>
                    </el-input>
                    <span style="color: red;">当前可用绿豆数量：{{dialogInsuranceForm.canUseCount}}</span>【提示：10绿豆价值1元，请谨慎操作!】
                </el-form-item>
                <el-form-item label="原因" style="margin-left: 0px" label-width="120px" prop="remark">
                    <el-input :rows="4"  placeholder="请输入操作理由" size="medium"
                              type="textarea"
                              v-model="dialogInsuranceForm.remark"></el-input>
                </el-form-item>

            </el-form>
            <div class="dialog-footer" slot="footer">

                <el-button @click="saveDeductionMungBean()" type="primary">确认无误</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="insuranceMungBeanVisible" label-width="80px" title="收支明细"
                   width="50%">
            <el-row>

                <el-date-picker type="datetimerange" v-model="dialogInsuranceForm.startEndTime" start-placeholder="开始时间" placeholder="按发布时间筛选" end-placeholder="结束时间" @change="loadInsuranceMungOrderData()">
                </el-date-picker>

            </el-row>

            <el-table :data="mungBeanDatas" class="basic-margin" style="width: 100%">
                <el-table-column label="业务类型">
                    <template scope="scope">
                        {{scope.row.type|typeFilter}}
                    </template>
                </el-table-column>
                <el-table-column label="记账类型">
                    <template scope="scope">
                        <span v-bind:style="{color:getTypeColor(scope.row.type)}">  {{scope.row.type|incomeTypeFilter}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="数量（粒）">
                    <template scope="scope">
                        {{scope.row.count}}
                    </template>
                </el-table-column>
                <el-table-column label="备注">
                    <template scope="scope">
                        {{scope.row.mungBeanRemark}}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template scope="scope">
                        {{scope.row.createTime|dateTimeFormat}}
                    </template>
                </el-table-column>

            </el-table>

            <el-pagination
                    class="row basic-margin"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="incomeCurrentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="incomePageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="incomeTotalCount">
            </el-pagination>

        </el-dialog>

        <el-dialog :visible.sync="insuranceOrderVisible" label-width="80px" title="智保订单"
                   width="50%">
            <el-table :data="insuranceOrderData" class="basic-margin" style="width: 100%">
                <el-table-column label="保单号">
                    <template scope="scope">
                        {{scope.row.number}}
                    </template>
                </el-table-column>
                <el-table-column label="姓名">
                    <template scope="scope">
                        {{scope.row.insuredName}}
                    </template>
                </el-table-column>
                <el-table-column label="手机号">
                    <template scope="scope">
                        {{scope.row.insuredPhone}}
                    </template>
                </el-table-column>
                <el-table-column label="保险公司">
                    <template scope="scope">
                        {{scope.row.companyName}}
                    </template>
                </el-table-column>
                <el-table-column label="保险金额(元)">
                    <template scope="scope">
                        {{scope.row.costs/100}}
                    </template>
                </el-table-column>
                <el-table-column label="保险到期" width="160px">
                    <template scope="scope">
                        {{scope.row.effectiveEndTime|dateTimeFormat}}
                    </template>
                </el-table-column>
                <el-table-column label="绿豆奖励(粒)">
                    <template scope="scope">
                        {{scope.row.maxCount}}
                    </template>
                </el-table-column>

            </el-table>

        </el-dialog>
    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import insuranceModel from '@/framework/models/insuranceModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'insuranceUserList',
  data: function () {
    return {
      datas: null,
      mungBeanDatas: null,
      queryParams: {
        keyword: null
      },
      incomePageSize: 10,
      incomeCurrentPage: 1,
      incomeTotalCount: 0,
      dialogInsuranceForm: {
        id: null,
        count: null,
        remark: null,
        startEndTime: null,
        canUseCount: null
      },
      deductionDialogInsuranceUserVisible: false,
      dialogInsuranceUserFormVisible: false,
      insuranceMungBeanVisible: false,
      insuranceOrderVisible: false,
      insuranceOrderData: null,
      rules: {
        count: [{
          required: true,
          trigger: 'change',
          message: '绿豆不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '绿豆只能为数字！'
        }]
      }
    }
  },
  filters: {
    typeFilter (value) {
      let filterValue = '暂无'
      switch (value) {
        case 1:// 提现
          filterValue = '提现'
          break
        case 2:// 兑换商品
          filterValue = '兑换商品'
          break
        case 3:// 环保奖励
          filterValue = '环保奖励'
          break
        case 4:// 消耗绿豆
          filterValue = '消耗绿豆'
          break
        case 5:// 5商家商品消耗
          filterValue = '商家商品消耗'
          break
        case 6:// 手动奖励
          filterValue = '手动奖励'
          break
        case 7:// 商品活动
          filterValue = '手动扣减'
          break
        case 8:// 省心加油
          filterValue = '省心加油'
          break
        case 9:
          filterValue = '省心加油'
          break
      }
      return filterValue
    },
    incomeTypeFilter (value) {
      let filterValue = ''
      switch (value) {
        case 1:// 提现
          filterValue = '支出'
          break
        case 2:// 兑换商品
          filterValue = '支出'
          break
        case 3:// 环保奖励
          filterValue = '收入'
          break
        case 4:// 消耗绿豆
          filterValue = '支出'
          break
        case 5:// 5商家商品消耗
          filterValue = '支出'
          break
        case 6:// 手动奖励
          filterValue = '收入'
          break
        case 7:// 手动扣减
          filterValue = '支出'
          break
        case 8:// 省心加油
          filterValue = '收入'
          break
        case 9:// 省心加油
          filterValue = '收入'
          break
      }

      return filterValue
    }
  },
  methods: {
    getTypeColor (value) {
      let color = ''
      switch (value) {
        case 1:// 提现
          color = 'red'
          break
        case 2:// 兑换商品
          color = 'red'
          break
        case 3:// 环保奖励
          color = ''
          break
        case 4:// 消耗绿豆
          color = 'red'
          break
        case 5:// 5商家商品消耗
          color = 'red'
          break
        case 6:// 手动奖励
          color = ''
          break
        case 7:// 手动扣减
          color = 'red'
          break
        case 8:// 省心加油
          color = ''
          break
        case 9:// 省心加油
          color = ''
          break
      }
      return color
    },
    handleSizeChange (val) {
      this.incomePageSize = val
      this.loadInsuranceMungOrderData()
    },
    handleCurrentChange (val) {
      this.incomeCurrentPage = val
      this.loadInsuranceMungOrderData()
    },
    showInsuranceOrderData: function (id) {
      this.insuranceOrderVisible = true
      this.dialogInsuranceForm.id = id
      this.findMyInsuranceOrderList()
    },
    showInsuranceMungBeanData: function (id) {
      this.dialogInsuranceForm.id = id
      this.loadInsuranceMungOrderData()
      this.insuranceMungBeanVisible = true
    },
    rewardMungBean: function (row) {
      this.dialogInsuranceUserFormVisible = true
      this.dialogInsuranceForm.id = row.id
      this.dialogInsuranceForm.count = null
      this.dialogInsuranceForm.remark = null
    },
    deductionMungBean: function (row) {
      this.dialogInsuranceForm.id = row.id
      this.dialogInsuranceForm.remark = null
      this.dialogInsuranceForm.canUseCount = row.canUseCount
      this.dialogInsuranceForm.count = null
      this.deductionDialogInsuranceUserVisible = true
    },
    saveRewardMungBean: function () {
      let that = this
      let channelId = this.queryParams.channelId
      let param = { id: this.dialogInsuranceForm.id, count: this.dialogInsuranceForm.count, remark: this.dialogInsuranceForm.remark, channelId: channelId }

      let listener = {
        success: function (dataInfo) {
          that.dialogInsuranceUserFormVisible = false
          that.$refs.insuranceUserListTable.search()
        }
      }
      insuranceModel.saveRewardMungBean(that, param, listener)
    },
    findMyInsuranceOrderList: function () {
      let that = this
      let channelId = this.queryParams.channelId
      let param = { id: this.dialogInsuranceForm.id, channelId: channelId }

      let listener = {
        success: function (dataInfo) {
          that.insuranceOrderData = dataInfo.datas
        }
      }
      insuranceModel.findMyInsuranceOrderList(that, param, listener)
    },
    saveDeductionMungBean: function () {
      if (this.dialogInsuranceForm.canUseCount < this.dialogInsuranceForm.count) {
        this.$message({
          type: 'error',
          message: '扣减绿豆数量大于可用绿豆数量'
        })
        return
      }

      let that = this
      let channelId = this.queryParams.channelId
      let param = { id: this.dialogInsuranceForm.id, count: this.dialogInsuranceForm.count, remark: this.dialogInsuranceForm.remark, channelId: channelId }

      let listener = {
        success: function (dataInfo) {
          that.deductionDialogInsuranceUserVisible = false
          that.$refs.insuranceUserListTable.search()
        }
      }
      insuranceModel.saveDeductionMungBean(that, param, listener)
    },
    loadInsuranceMungOrderData: function () {
      let _this = this
      let params = {
        id: this.dialogInsuranceForm.id,
        pageNum: this.incomeCurrentPage,
        pageSize: this.incomePageSize
      }

      if (_this.dialogInsuranceForm.startEndTime && _this.dialogInsuranceForm.startEndTime.length === 2) {
        let startTime = _this.dialogInsuranceForm.startEndTime[0]
        let endTime = _this.dialogInsuranceForm.startEndTime[1]
        if (startTime) {
          params.startTime = startTime.getTime()
        }
        if (endTime) {
          params.endTime = endTime.getTime()
        }
      }

      let listener = {
        success: function (dataInfo) {
          _this.mungBeanDatas = dataInfo.data
          _this.incomeTotalCount = dataInfo.recordsTotal
        }
      }
      insuranceModel.findMyMungBean(this, params, listener)
    }
  }
}
</script>

<style scoped>
</style>
